const modules = import.meta.glob('./*/*.ts', { eager: true });

const messages: Record<string, Record<string, unknown>> = {};

Object.keys(modules).forEach((path) => {
  const match = path.match(/\.\/([^/]+)\/([^/]+)\.ts$/);
  if (match) {
    const [, lang, namespace] = match;
    const module = modules[path] as Record<string, unknown>;

    if (!messages[lang]) {
      messages[lang] = {};
    }

    // 各名前空間を個別の named export（例: export const home = {...}）から取り込む。
    if (module[namespace]) {
      messages[lang][namespace] = module[namespace];
    }
  }
});

export default messages;
